import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
} from 'recharts';
import type { ChartPoint } from '../../hooks/useAnalytics';

interface TopUsersChartProps {
  data: ChartPoint[];
}

export const TopUsersChart = ({ data }: TopUsersChartProps) => (
  <div className="bg-white rounded-lg border border-slate-200 p-4">
    <h3 className="text-sm font-semibold text-slate-700 mb-4">Most Active Users</h3>
    {data.length === 0 ? (
      <p className="text-xs text-slate-400 py-8 text-center">No data</p>
    ) : (
      <ResponsiveContainer width="100%" height={Math.max(220, data.length * 34)}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 0, right: 24, left: 8, bottom: 0 }}
        >
          <XAxis type="number" tick={{ fontSize: 11 }} allowDecimals={false} />
          <YAxis
            type="category"
            dataKey="name"
            width={130}
            tick={{ fontSize: 11 }}
          />
          <Tooltip
            contentStyle={{ fontSize: 12 }}
            formatter={(v) => [v, 'Conversations']}
          />
          <Bar dataKey="count" fill="#089d3c" radius={[0, 3, 3, 0]} />
        </BarChart>
      </ResponsiveContainer>
    )}
  </div>
);
